const ItemId = {
  __MULTI_TARGET__: "__multi_target__",
  ITEM_ACTIVITY_XIRANITE_BOTTLE: "item_activity_xiranite_bottle",
  ITEM_ACTIVITY_XIRANITE_CMPT: "item_activity_xiranite_cmpt",
  ITEM_ACTIVITY_XIRANITE_ENR_BOTTLE: "item_activity_xiranite_enr_bottle",
  ITEM_ACTIVITY_XIRANITE_ENR_CMPT: "item_activity_xiranite_enr_cmpt",
  ITEM_ACTIVITY_XIRANITE_ENR_HULU: "item_activity_xiranite_enr_hulu",
  ITEM_ACTIVITY_XIRANITE_ENR_TOOL: "item_activity_xiranite_enr_tool",
  ITEM_ACTIVITY_XIRANITE_HULU: "item_activity_xiranite_hulu",
  ITEM_BOTTLED_FOOD_1: "item_bottled_food_1",
  ITEM_BOTTLED_FOOD_2: "item_bottled_food_2",
  ITEM_BOTTLED_FOOD_3: "item_bottled_food_3",
  ITEM_BOTTLED_FOOD_4: "item_bottled_food_4",
  ITEM_BOTTLED_FOOD_5: "item_bottled_food_5",
  ITEM_BOTTLED_REC_HP_1: "item_bottled_rec_hp_1",
  ITEM_BOTTLED_REC_HP_2: "item_bottled_rec_hp_2",
  ITEM_BOTTLED_REC_HP_3: "item_bottled_rec_hp_3",
  ITEM_BOTTLED_REC_HP_4: "item_bottled_rec_hp_4",
  ITEM_BOTTLED_REC_HP_5: "item_bottled_rec_hp_5",
  ITEM_CARBON_ENR: "item_carbon_enr",
  ITEM_CARBON_ENR_POWDER: "item_carbon_enr_powder",
  ITEM_CARBON_MTL: "item_carbon_mtl",
  ITEM_CARBON_POWDER: "item_carbon_powder",
  ITEM_COPPER_BOTTLE: "item_copper_bottle",
  ITEM_COPPER_CMPT: "item_copper_cmpt",
  ITEM_COPPER_ENR: "item_copper_enr",
  ITEM_COPPER_ENR_BOTTLE: "item_copper_enr_bottle",
  ITEM_COPPER_ENR_CMPT: "item_copper_enr_cmpt",
  ITEM_COPPER_NUGGET: "item_copper_nugget",
  ITEM_COPPER_ORE: "item_copper_ore",
  ITEM_COPPER_POWDER: "item_copper_powder",
  ITEM_CRYSTAL_ENR: "item_crystal_enr",
  ITEM_CRYSTAL_ENR_POWDER: "item_crystal_enr_powder",
  ITEM_CRYSTAL_POWDER: "item_crystal_powder",
  ITEM_CRYSTAL_SHELL: "item_crystal_shell",
  ITEM_EQUIP_SCRIPT_1: "item_equip_script_1",
  ITEM_EQUIP_SCRIPT_2: "item_equip_script_2",
  ITEM_EQUIP_SCRIPT_3: "item_equip_script_3",
  ITEM_EQUIP_SCRIPT_4: "item_equip_script_4",
  ITEM_EQUIP_SCRIPT_4_1: "item_equip_script_4_1",
  ITEM_EQUIP_SCRIPT_4_2: "item_equip_script_4_2",
  ITEM_FBOTTLE_COPPER_ACID: "item_fbottle_copper_acid",
  ITEM_FBOTTLE_COPPER_COPPER: "item_fbottle_copper_copper",
  ITEM_FBOTTLE_COPPER_COPPER_ENR: "item_fbottle_copper_copper_enr",
  ITEM_FBOTTLE_COPPER_GRASS_1: "item_fbottle_copper_grass_1",
  ITEM_FBOTTLE_COPPER_GRASS_2: "item_fbottle_copper_grass_2",
  ITEM_FBOTTLE_COPPER_SEWAGE: "item_fbottle_copper_sewage",
  ITEM_FBOTTLE_COPPER_WATER: "item_fbottle_copper_water",
  ITEM_FBOTTLE_COPPER_XIRANITE: "item_fbottle_copper_xiranite",
  ITEM_FBOTTLE_COPPER_XIRANITE_ENR: "item_fbottle_copper_xiranite_enr",
  ITEM_FBOTTLE_COPPER_XIRANITE_LOWPOLY: "item_fbottle_copper_xiranite_lowpoly",
  ITEM_FBOTTLE_COPPER_XIRANITE_POLY: "item_fbottle_copper_xiranite_poly",
  ITEM_FBOTTLE_COPPERENR_ACID: "item_fbottle_copperenr_acid",
  ITEM_FBOTTLE_COPPERENR_COPPER: "item_fbottle_copperenr_copper",
  ITEM_FBOTTLE_COPPERENR_COPPER_ENR: "item_fbottle_copperenr_copper_enr",
  ITEM_FBOTTLE_COPPERENR_GRASS_1: "item_fbottle_copperenr_grass_1",
  ITEM_FBOTTLE_COPPERENR_GRASS_2: "item_fbottle_copperenr_grass_2",
  ITEM_FBOTTLE_COPPERENR_SEWAGE: "item_fbottle_copperenr_sewage",
  ITEM_FBOTTLE_COPPERENR_WATER: "item_fbottle_copperenr_water",
  ITEM_FBOTTLE_COPPERENR_XIRANITE: "item_fbottle_copperenr_xiranite",
  ITEM_FBOTTLE_COPPERENR_XIRANITE_ENR: "item_fbottle_copperenr_xiranite_enr",
  ITEM_FBOTTLE_COPPERENR_XIRANITE_LOWPOLY:
    "item_fbottle_copperenr_xiranite_lowpoly",
  ITEM_FBOTTLE_COPPERENR_XIRANITE_POLY: "item_fbottle_copperenr_xiranite_poly",
  ITEM_FBOTTLE_GLASS_ACID: "item_fbottle_glass_acid",
  ITEM_FBOTTLE_GLASS_COPPER: "item_fbottle_glass_copper",
  ITEM_FBOTTLE_GLASS_COPPER_ENR: "item_fbottle_glass_copper_enr",
  ITEM_FBOTTLE_GLASS_GRASS_1: "item_fbottle_glass_grass_1",
  ITEM_FBOTTLE_GLASS_GRASS_2: "item_fbottle_glass_grass_2",
  ITEM_FBOTTLE_GLASS_SEWAGE: "item_fbottle_glass_sewage",
  ITEM_FBOTTLE_GLASS_WATER: "item_fbottle_glass_water",
  ITEM_FBOTTLE_GLASS_XIRANITE: "item_fbottle_glass_xiranite",
  ITEM_FBOTTLE_GLASS_XIRANITE_ENR: "item_fbottle_glass_xiranite_enr",
  ITEM_FBOTTLE_GLASS_XIRANITE_LOWPOLY: "item_fbottle_glass_xiranite_lowpoly",
  ITEM_FBOTTLE_GLASS_XIRANITE_POLY: "item_fbottle_glass_xiranite_poly",
  ITEM_FBOTTLE_GLASSENR_ACID: "item_fbottle_glassenr_acid",
  ITEM_FBOTTLE_GLASSENR_COPPER: "item_fbottle_glassenr_copper",
  ITEM_FBOTTLE_GLASSENR_COPPER_ENR: "item_fbottle_glassenr_copper_enr",
  ITEM_FBOTTLE_GLASSENR_GRASS_1: "item_fbottle_glassenr_grass_1",
  ITEM_FBOTTLE_GLASSENR_GRASS_2: "item_fbottle_glassenr_grass_2",
  ITEM_FBOTTLE_GLASSENR_SEWAGE: "item_fbottle_glassenr_sewage",
  ITEM_FBOTTLE_GLASSENR_WATER: "item_fbottle_glassenr_water",
  ITEM_FBOTTLE_GLASSENR_XIRANITE: "item_fbottle_glassenr_xiranite",
  ITEM_FBOTTLE_GLASSENR_XIRANITE_ENR: "item_fbottle_glassenr_xiranite_enr",
  ITEM_FBOTTLE_GLASSENR_XIRANITE_LOWPOLY:
    "item_fbottle_glassenr_xiranite_lowpoly",
  ITEM_FBOTTLE_GLASSENR_XIRANITE_POLY: "item_fbottle_glassenr_xiranite_poly",
  ITEM_FBOTTLE_IRON_ACID: "item_fbottle_iron_acid",
  ITEM_FBOTTLE_IRON_COPPER: "item_fbottle_iron_copper",
  ITEM_FBOTTLE_IRON_COPPER_ENR: "item_fbottle_iron_copper_enr",
  ITEM_FBOTTLE_IRON_GRASS_1: "item_fbottle_iron_grass_1",
  ITEM_FBOTTLE_IRON_GRASS_2: "item_fbottle_iron_grass_2",
  ITEM_FBOTTLE_IRON_SEWAGE: "item_fbottle_iron_sewage",
  ITEM_FBOTTLE_IRON_WATER: "item_fbottle_iron_water",
  ITEM_FBOTTLE_IRON_XIRANITE: "item_fbottle_iron_xiranite",
  ITEM_FBOTTLE_IRON_XIRANITE_ENR: "item_fbottle_iron_xiranite_enr",
  ITEM_FBOTTLE_IRON_XIRANITE_LOWPOLY: "item_fbottle_iron_xiranite_lowpoly",
  ITEM_FBOTTLE_IRON_XIRANITE_POLY: "item_fbottle_iron_xiranite_poly",
  ITEM_FBOTTLE_IRONENR_ACID: "item_fbottle_ironenr_acid",
  ITEM_FBOTTLE_IRONENR_COPPER: "item_fbottle_ironenr_copper",
  ITEM_FBOTTLE_IRONENR_COPPER_ENR: "item_fbottle_ironenr_copper_enr",
  ITEM_FBOTTLE_IRONENR_GRASS_1: "item_fbottle_ironenr_grass_1",
  ITEM_FBOTTLE_IRONENR_GRASS_2: "item_fbottle_ironenr_grass_2",
  ITEM_FBOTTLE_IRONENR_SEWAGE: "item_fbottle_ironenr_sewage",
  ITEM_FBOTTLE_IRONENR_WATER: "item_fbottle_ironenr_water",
  ITEM_FBOTTLE_IRONENR_XIRANITE: "item_fbottle_ironenr_xiranite",
  ITEM_FBOTTLE_IRONENR_XIRANITE_ENR: "item_fbottle_ironenr_xiranite_enr",
  ITEM_FBOTTLE_IRONENR_XIRANITE_LOWPOLY:
    "item_fbottle_ironenr_xiranite_lowpoly",
  ITEM_FBOTTLE_IRONENR_XIRANITE_POLY: "item_fbottle_ironenr_xiranite_poly",
  ITEM_FBOTTLE_XIRANENR_GRASS_2: "item_fbottle_xiranenr_grass_2",
  ITEM_GLASS_BOTTLE: "item_glass_bottle",
  ITEM_GLASS_CMPT: "item_glass_cmpt",
  ITEM_GLASS_ENR_BOTTLE: "item_glass_enr_bottle",
  ITEM_GLASS_ENR_CMPT: "item_glass_enr_cmpt",
  ITEM_IRON_BOTTLE: "item_iron_bottle",
  ITEM_IRON_CMPT: "item_iron_cmpt",
  ITEM_IRON_ENR: "item_iron_enr",
  ITEM_IRON_ENR_BOTTLE: "item_iron_enr_bottle",
  ITEM_IRON_ENR_CMPT: "item_iron_enr_cmpt",
  ITEM_IRON_ENR_POWDER: "item_iron_enr_powder",
  ITEM_IRON_NUGGET: "item_iron_nugget",
  ITEM_IRON_ORE: "item_iron_ore",
  ITEM_IRON_POWDER: "item_iron_powder",
  ITEM_LIQUID_ACID: "item_liquid_acid",
  ITEM_LIQUID_COPPER: "item_liquid_copper",
  ITEM_LIQUID_COPPER_ENR: "item_liquid_copper_enr",
  ITEM_LIQUID_PLANT_GRASS_1: "item_liquid_plant_grass_1",
  ITEM_LIQUID_PLANT_GRASS_2: "item_liquid_plant_grass_2",
  ITEM_LIQUID_SEWAGE: "item_liquid_sewage",
  ITEM_LIQUID_WATER: "item_liquid_water",
  ITEM_LIQUID_XIRANITE: "item_liquid_xiranite",
  ITEM_LIQUID_XIRANITE_ENR: "item_liquid_xiranite_enr",
  ITEM_LIQUID_XIRANITE_LOWPOLY: "item_liquid_xiranite_lowpoly",
  ITEM_LIQUID_XIRANITE_POLY: "item_liquid_xiranite_poly",
  ITEM_MUCK_FECES_1: "item_muck_feces_1",
  ITEM_MUCK_XIRANITE_1: "item_muck_xiranite_1",
  ITEM_ORIGINIUM_ENR_POWDER: "item_originium_enr_powder",
  ITEM_ORIGINIUM_ORE: "item_originium_ore",
  ITEM_ORIGINIUM_POWDER: "item_originium_powder",
  ITEM_PLANT_BBFLOWER_1: "item_plant_bbflower_1",
  ITEM_PLANT_BBFLOWER_POWDER_1: "item_plant_bbflower_powder_1",
  ITEM_PLANT_BBFLOWER_SEED_1: "item_plant_bbflower_seed_1",
  ITEM_PLANT_GRASS_1: "item_plant_grass_1",
  ITEM_PLANT_GRASS_2: "item_plant_grass_2",
  ITEM_PLANT_GRASS_POWDER_1: "item_plant_grass_powder_1",
  ITEM_PLANT_GRASS_POWDER_2: "item_plant_grass_powder_2",
  ITEM_PLANT_GRASS_SEED_1: "item_plant_grass_seed_1",
  ITEM_PLANT_GRASS_SEED_2: "item_plant_grass_seed_2",
  ITEM_PLANT_MOSS_1: "item_plant_moss_1",
  ITEM_PLANT_MOSS_2: "item_plant_moss_2",
  ITEM_PLANT_MOSS_3: "item_plant_moss_3",
  ITEM_PLANT_MOSS_ENR_POWDER_1: "item_plant_moss_enr_powder_1",
  ITEM_PLANT_MOSS_ENR_POWDER_2: "item_plant_moss_enr_powder_2",
  ITEM_PLANT_MOSS_POWDER_1: "item_plant_moss_powder_1",
  ITEM_PLANT_MOSS_POWDER_2: "item_plant_moss_powder_2",
  ITEM_PLANT_MOSS_POWDER_3: "item_plant_moss_powder_3",
  ITEM_PLANT_MOSS_SEED_1: "item_plant_moss_seed_1",
  ITEM_PLANT_MOSS_SEED_2: "item_plant_moss_seed_2",
  ITEM_PLANT_MOSS_SEED_3: "item_plant_moss_seed_3",
  ITEM_PLANT_SP_1: "item_plant_sp_1",
  ITEM_PLANT_SP_2: "item_plant_sp_2",
  ITEM_PLANT_SP_3: "item_plant_sp_3",
  ITEM_PLANT_SP_4: "item_plant_sp_4",
  ITEM_PLANT_SP_SEED_1: "item_plant_sp_seed_1",
  ITEM_PLANT_SP_SEED_2: "item_plant_sp_seed_2",
  ITEM_PLANT_SP_SEED_3: "item_plant_sp_seed_3",
  ITEM_PLANT_SP_SEED_4: "item_plant_sp_seed_4",
  ITEM_PLANT_TUNDRA_WOOD: "item_plant_tundra_wood",
  ITEM_PROC_BATTERY_1: "item_proc_battery_1",
  ITEM_PROC_BATTERY_2: "item_proc_battery_2",
  ITEM_PROC_BATTERY_3: "item_proc_battery_3",
  ITEM_PROC_BATTERY_4: "item_proc_battery_4",
  ITEM_PROC_BATTERY_5: "item_proc_battery_5",
  ITEM_PROC_BOMB_1: "item_proc_bomb_1",
  ITEM_QUARTZ_ENR: "item_quartz_enr",
  ITEM_QUARTZ_ENR_POWDER: "item_quartz_enr_powder",
  ITEM_QUARTZ_GLASS: "item_quartz_glass",
  ITEM_QUARTZ_POWDER: "item_quartz_powder",
  ITEM_QUARTZ_SAND: "item_quartz_sand",
  ITEM_XIRANITE_ENR_POWDER: "item_xiranite_enr_powder",
  ITEM_XIRANITE_POLY: "item_xiranite_poly",
  ITEM_XIRANITE_POWDER: "item_xiranite_powder",
} as const;
type ItemId = (typeof ItemId)[keyof typeof ItemId];

const RecipeId = {
  COMPONENT_ACTIVITY_XIRANITE_CMPT_1: "component_activity_xiranite_cmpt_1",
  COMPONENT_ACTIVITY_XIRANITE_ENR_CMPT_1:
    "component_activity_xiranite_enr_cmpt_1",
  COMPONENT_COPPER_CMPT_1: "component_copper_cmpt_1",
  COMPONENT_COPPER_ENR_CMPT_1: "component_copper_enr_cmpt_1",
  COMPONENT_GLASS_CMPT_1: "component_glass_cmpt_1",
  COMPONENT_GLASS_ENR_CMPT_1: "component_glass_enr_cmpt_1",
  COMPONENT_IRON_CMPT_1: "component_iron_cmpt_1",
  COMPONENT_IRON_ENR_CMPT_1: "component_iron_enr_cmpt_1",
  DISMANTLER_COPPER_ACID_1: "dismantler_copper_acid_1",
  DISMANTLER_COPPER_COPPER_1: "dismantler_copper_copper_1",
  DISMANTLER_COPPER_COPPER_ENR_1: "dismantler_copper_copper_enr_1",
  DISMANTLER_COPPER_GRASS_1_1: "dismantler_copper_grass_1_1",
  DISMANTLER_COPPER_GRASS_2_1: "dismantler_copper_grass_2_1",
  DISMANTLER_COPPER_SEWAGE_1: "dismantler_copper_sewage_1",
  DISMANTLER_COPPER_WATER_1: "dismantler_copper_water_1",
  DISMANTLER_COPPER_XIRANITE_1: "dismantler_copper_xiranite_1",
  DISMANTLER_COPPER_XIRANITE_ENR_1: "dismantler_copper_xiranite_enr_1",
  DISMANTLER_COPPER_XIRANITE_LOWPOLY_1: "dismantler_copper_xiranite_lowpoly_1",
  DISMANTLER_COPPER_XIRANITE_POLY_1: "dismantler_copper_xiranite_poly_1",
  DISMANTLER_COPPERENR_ACID_1: "dismantler_copperenr_acid_1",
  DISMANTLER_COPPERENR_COPPER_1: "dismantler_copperenr_copper_1",
  DISMANTLER_COPPERENR_COPPER_ENR_1: "dismantler_copperenr_copper_enr_1",
  DISMANTLER_COPPERENR_GRASS_1_1: "dismantler_copperenr_grass_1_1",
  DISMANTLER_COPPERENR_GRASS_2_1: "dismantler_copperenr_grass_2_1",
  DISMANTLER_COPPERENR_SEWAGE_1: "dismantler_copperenr_sewage_1",
  DISMANTLER_COPPERENR_WATER_1: "dismantler_copperenr_water_1",
  DISMANTLER_COPPERENR_XIRANITE_1: "dismantler_copperenr_xiranite_1",
  DISMANTLER_COPPERENR_XIRANITE_ENR_1: "dismantler_copperenr_xiranite_enr_1",
  DISMANTLER_COPPERENR_XIRANITE_LOWPOLY_1:
    "dismantler_copperenr_xiranite_lowpoly_1",
  DISMANTLER_COPPERENR_XIRANITE_POLY_1: "dismantler_copperenr_xiranite_poly_1",
  DISMANTLER_GLASS_ACID_1: "dismantler_glass_acid_1",
  DISMANTLER_GLASS_COPPER_1: "dismantler_glass_copper_1",
  DISMANTLER_GLASS_COPPER_ENR_1: "dismantler_glass_copper_enr_1",
  DISMANTLER_GLASS_GRASS_1_1: "dismantler_glass_grass_1_1",
  DISMANTLER_GLASS_GRASS_2_1: "dismantler_glass_grass_2_1",
  DISMANTLER_GLASS_SEWAGE_1: "dismantler_glass_sewage_1",
  DISMANTLER_GLASS_WATER_1: "dismantler_glass_water_1",
  DISMANTLER_GLASS_XIRANITE_1: "dismantler_glass_xiranite_1",
  DISMANTLER_GLASS_XIRANITE_ENR_1: "dismantler_glass_xiranite_enr_1",
  DISMANTLER_GLASS_XIRANITE_LOWPOLY_1: "dismantler_glass_xiranite_lowpoly_1",
  DISMANTLER_GLASS_XIRANITE_POLY_1: "dismantler_glass_xiranite_poly_1",
  DISMANTLER_GLASSENR_ACID_1: "dismantler_glassenr_acid_1",
  DISMANTLER_GLASSENR_COPPER_1: "dismantler_glassenr_copper_1",
  DISMANTLER_GLASSENR_COPPER_ENR_1: "dismantler_glassenr_copper_enr_1",
  DISMANTLER_GLASSENR_GRASS_1_1: "dismantler_glassenr_grass_1_1",
  DISMANTLER_GLASSENR_GRASS_2_1: "dismantler_glassenr_grass_2_1",
  DISMANTLER_GLASSENR_SEWAGE_1: "dismantler_glassenr_sewage_1",
  DISMANTLER_GLASSENR_WATER_1: "dismantler_glassenr_water_1",
  DISMANTLER_GLASSENR_XIRANITE_1: "dismantler_glassenr_xiranite_1",
  DISMANTLER_GLASSENR_XIRANITE_ENR_1: "dismantler_glassenr_xiranite_enr_1",
  DISMANTLER_GLASSENR_XIRANITE_LOWPOLY_1:
    "dismantler_glassenr_xiranite_lowpoly_1",
  DISMANTLER_GLASSENR_XIRANITE_POLY_1: "dismantler_glassenr_xiranite_poly_1",
  DISMANTLER_IRON_ACID_1: "dismantler_iron_acid_1",
  DISMANTLER_IRON_COPPER_1: "dismantler_iron_copper_1",
  DISMANTLER_IRON_COPPER_ENR_1: "dismantler_iron_copper_enr_1",
  DISMANTLER_IRON_GRASS_1_1: "dismantler_iron_grass_1_1",
  DISMANTLER_IRON_GRASS_2_1: "dismantler_iron_grass_2_1",
  DISMANTLER_IRON_SEWAGE_1: "dismantler_iron_sewage_1",
  DISMANTLER_IRON_WATER_1: "dismantler_iron_water_1",
  DISMANTLER_IRON_XIRANITE_1: "dismantler_iron_xiranite_1",
  DISMANTLER_IRON_XIRANITE_ENR_1: "dismantler_iron_xiranite_enr_1",
  DISMANTLER_IRON_XIRANITE_LOWPOLY_1: "dismantler_iron_xiranite_lowpoly_1",
  DISMANTLER_IRON_XIRANITE_POLY_1: "dismantler_iron_xiranite_poly_1",
  DISMANTLER_IRONENR_ACID_1: "dismantler_ironenr_acid_1",
  DISMANTLER_IRONENR_COPPER_1: "dismantler_ironenr_copper_1",
  DISMANTLER_IRONENR_COPPER_ENR_1: "dismantler_ironenr_copper_enr_1",
  DISMANTLER_IRONENR_GRASS_1_1: "dismantler_ironenr_grass_1_1",
  DISMANTLER_IRONENR_GRASS_2_1: "dismantler_ironenr_grass_2_1",
  DISMANTLER_IRONENR_SEWAGE_1: "dismantler_ironenr_sewage_1",
  DISMANTLER_IRONENR_WATER_1: "dismantler_ironenr_water_1",
  DISMANTLER_IRONENR_XIRANITE_1: "dismantler_ironenr_xiranite_1",
  DISMANTLER_IRONENR_XIRANITE_ENR_1: "dismantler_ironenr_xiranite_enr_1",
  DISMANTLER_IRONENR_XIRANITE_LOWPOLY_1:
    "dismantler_ironenr_xiranite_lowpoly_1",
  DISMANTLER_IRONENR_XIRANITE_POLY_1: "dismantler_ironenr_xiranite_poly_1",
  DISMANTLER_XIRANENR_GRASS_2_1: "dismantler_xiranenr_grass_2_1",
  FILLING_BOTTLED_COPPER_ACID: "filling_bottled_copper_acid",
  FILLING_BOTTLED_COPPER_COPPER: "filling_bottled_copper_copper",
  FILLING_BOTTLED_COPPER_COPPER_ENR: "filling_bottled_copper_copper_enr",
  FILLING_BOTTLED_COPPER_GRASS_1: "filling_bottled_copper_grass_1",
  FILLING_BOTTLED_COPPER_GRASS_2: "filling_bottled_copper_grass_2",
  FILLING_BOTTLED_COPPER_SEWAGE: "filling_bottled_copper_sewage",
  FILLING_BOTTLED_COPPER_WATER: "filling_bottled_copper_water",
  FILLING_BOTTLED_COPPER_XIRANITE: "filling_bottled_copper_xiranite",
  FILLING_BOTTLED_COPPER_XIRANITE_ENR: "filling_bottled_copper_xiranite_enr",
  FILLING_BOTTLED_COPPER_XIRANITE_LOWPOLY:
    "filling_bottled_copper_xiranite_lowpoly",
  FILLING_BOTTLED_COPPER_XIRANITE_POLY: "filling_bottled_copper_xiranite_poly",
  FILLING_BOTTLED_COPPERENR_ACID: "filling_bottled_copperenr_acid",
  FILLING_BOTTLED_COPPERENR_COPPER: "filling_bottled_copperenr_copper",
  FILLING_BOTTLED_COPPERENR_COPPER_ENR: "filling_bottled_copperenr_copper_enr",
  FILLING_BOTTLED_COPPERENR_GRASS_1: "filling_bottled_copperenr_grass_1",
  FILLING_BOTTLED_COPPERENR_GRASS_2: "filling_bottled_copperenr_grass_2",
  FILLING_BOTTLED_COPPERENR_SEWAGE: "filling_bottled_copperenr_sewage",
  FILLING_BOTTLED_COPPERENR_WATER: "filling_bottled_copperenr_water",
  FILLING_BOTTLED_COPPERENR_XIRANITE: "filling_bottled_copperenr_xiranite",
  FILLING_BOTTLED_COPPERENR_XIRANITE_ENR:
    "filling_bottled_copperenr_xiranite_enr",
  FILLING_BOTTLED_COPPERENR_XIRANITE_LOWPOLY:
    "filling_bottled_copperenr_xiranite_lowpoly",
  FILLING_BOTTLED_COPPERENR_XIRANITE_POLY:
    "filling_bottled_copperenr_xiranite_poly",
  FILLING_BOTTLED_FOOD_1_1: "filling_bottled_food_1_1",
  FILLING_BOTTLED_FOOD_2_1: "filling_bottled_food_2_1",
  FILLING_BOTTLED_FOOD_3_1: "filling_bottled_food_3_1",
  FILLING_BOTTLED_GLASS_ACID: "filling_bottled_glass_acid",
  FILLING_BOTTLED_GLASS_COPPER: "filling_bottled_glass_copper",
  FILLING_BOTTLED_GLASS_COPPER_ENR: "filling_bottled_glass_copper_enr",
  FILLING_BOTTLED_GLASS_GRASS_1: "filling_bottled_glass_grass_1",
  FILLING_BOTTLED_GLASS_GRASS_2: "filling_bottled_glass_grass_2",
  FILLING_BOTTLED_GLASS_SEWAGE: "filling_bottled_glass_sewage",
  FILLING_BOTTLED_GLASS_WATER: "filling_bottled_glass_water",
  FILLING_BOTTLED_GLASS_XIRANITE: "filling_bottled_glass_xiranite",
  FILLING_BOTTLED_GLASS_XIRANITE_ENR: "filling_bottled_glass_xiranite_enr",
  FILLING_BOTTLED_GLASS_XIRANITE_LOWPOLY:
    "filling_bottled_glass_xiranite_lowpoly",
  FILLING_BOTTLED_GLASS_XIRANITE_POLY: "filling_bottled_glass_xiranite_poly",
  FILLING_BOTTLED_GLASSENR_ACID: "filling_bottled_glassenr_acid",
  FILLING_BOTTLED_GLASSENR_COPPER: "filling_bottled_glassenr_copper",
  FILLING_BOTTLED_GLASSENR_COPPER_ENR: "filling_bottled_glassenr_copper_enr",
  FILLING_BOTTLED_GLASSENR_GRASS_1: "filling_bottled_glassenr_grass_1",
  FILLING_BOTTLED_GLASSENR_GRASS_2: "filling_bottled_glassenr_grass_2",
  FILLING_BOTTLED_GLASSENR_SEWAGE: "filling_bottled_glassenr_sewage",
  FILLING_BOTTLED_GLASSENR_WATER: "filling_bottled_glassenr_water",
  FILLING_BOTTLED_GLASSENR_XIRANITE: "filling_bottled_glassenr_xiranite",
  FILLING_BOTTLED_GLASSENR_XIRANITE_ENR:
    "filling_bottled_glassenr_xiranite_enr",
  FILLING_BOTTLED_GLASSENR_XIRANITE_LOWPOLY:
    "filling_bottled_glassenr_xiranite_lowpoly",
  FILLING_BOTTLED_GLASSENR_XIRANITE_POLY:
    "filling_bottled_glassenr_xiranite_poly",
  FILLING_BOTTLED_IRON_ACID: "filling_bottled_iron_acid",
  FILLING_BOTTLED_IRON_COPPER: "filling_bottled_iron_copper",
  FILLING_BOTTLED_IRON_COPPER_ENR: "filling_bottled_iron_copper_enr",
  FILLING_BOTTLED_IRON_GRASS_1: "filling_bottled_iron_grass_1",
  FILLING_BOTTLED_IRON_GRASS_2: "filling_bottled_iron_grass_2",
  FILLING_BOTTLED_IRON_SEWAGE: "filling_bottled_iron_sewage",
  FILLING_BOTTLED_IRON_WATER: "filling_bottled_iron_water",
  FILLING_BOTTLED_IRON_XIRANITE: "filling_bottled_iron_xiranite",
  FILLING_BOTTLED_IRON_XIRANITE_ENR: "filling_bottled_iron_xiranite_enr",
  FILLING_BOTTLED_IRON_XIRANITE_LOWPOLY:
    "filling_bottled_iron_xiranite_lowpoly",
  FILLING_BOTTLED_IRON_XIRANITE_POLY: "filling_bottled_iron_xiranite_poly",
  FILLING_BOTTLED_IRONENR_ACID: "filling_bottled_ironenr_acid",
  FILLING_BOTTLED_IRONENR_COPPER: "filling_bottled_ironenr_copper",
  FILLING_BOTTLED_IRONENR_COPPER_ENR: "filling_bottled_ironenr_copper_enr",
  FILLING_BOTTLED_IRONENR_GRASS_1: "filling_bottled_ironenr_grass_1",
  FILLING_BOTTLED_IRONENR_GRASS_2: "filling_bottled_ironenr_grass_2",
  FILLING_BOTTLED_IRONENR_SEWAGE: "filling_bottled_ironenr_sewage",
  FILLING_BOTTLED_IRONENR_WATER: "filling_bottled_ironenr_water",
  FILLING_BOTTLED_IRONENR_XIRANITE: "filling_bottled_ironenr_xiranite",
  FILLING_BOTTLED_IRONENR_XIRANITE_ENR: "filling_bottled_ironenr_xiranite_enr",
  FILLING_BOTTLED_IRONENR_XIRANITE_LOWPOLY:
    "filling_bottled_ironenr_xiranite_lowpoly",
  FILLING_BOTTLED_IRONENR_XIRANITE_POLY:
    "filling_bottled_ironenr_xiranite_poly",
  FILLING_BOTTLED_REC_HP_1_1: "filling_bottled_rec_hp_1_1",
  FILLING_BOTTLED_REC_HP_2_1: "filling_bottled_rec_hp_2_1",
  FILLING_BOTTLED_REC_HP_3_1: "filling_bottled_rec_hp_3_1",
  FILLING_BOTTLED_XIRANENR_GRASS_2: "filling_bottled_xiranenr_grass_2",
  FLUID_CONSUME_LIQUID_CLEANER_1_ITEM_LIQUID_SEWAGE:
    "fluid_consume_liquid_cleaner_1_item_liquid_sewage",
  FLUID_CONSUME_LIQUID_CLEANER_1_ITEM_LIQUID_XIRANITE_LOWPOLY:
    "fluid_consume_liquid_cleaner_1_item_liquid_xiranite_lowpoly",
  FLUID_CONSUME_LIQUID_CLEANER_1_ITEM_LIQUID_XIRANITE_POLY:
    "fluid_consume_liquid_cleaner_1_item_liquid_xiranite_poly",
  FURNANCE_CARBON_ENR_1: "furnance_carbon_enr_1",
  FURNANCE_CARBON_ENR_POWDER_1: "furnance_carbon_enr_powder_1",
  FURNANCE_CARBON_ENR_POWDER_2: "furnance_carbon_enr_powder_2",
  FURNANCE_CARBON_MATERIAL_1: "furnance_carbon_material_1",
  FURNANCE_CARBON_MATERIAL_2: "furnance_carbon_material_2",
  FURNANCE_CARBON_MATERIAL_3: "furnance_carbon_material_3",
  FURNANCE_CARBON_MATERIAL_4: "furnance_carbon_material_4",
  FURNANCE_CARBON_MATERIAL_5: "furnance_carbon_material_5",
  FURNANCE_CARBON_MATERIAL_6: "furnance_carbon_material_6",
  FURNANCE_CARBON_POWDER_1: "furnance_carbon_powder_1",
  FURNANCE_CARBON_POWDER_2: "furnance_carbon_powder_2",
  FURNANCE_CARBON_POWDER_3: "furnance_carbon_powder_3",
  FURNANCE_CARBON_POWDER_4: "furnance_carbon_powder_4",
  FURNANCE_CARBON_POWDER_5: "furnance_carbon_powder_5",
  FURNANCE_COPPER_NUGGET_1: "furnance_copper_nugget_1",
  FURNANCE_CRYSTAL_ENR_1: "furnance_crystal_enr_1",
  FURNANCE_CRYSTAL_ENR_POWDER_1: "furnance_crystal_enr_powder_1",
  FURNANCE_CRYSTAL_POWDER_1: "furnance_crystal_powder_1",
  FURNANCE_CRYSTAL_SHELL_1: "furnance_crystal_shell_1",
  FURNANCE_CRYSTAL_SHELL_2: "furnance_crystal_shell_2",
  FURNANCE_IRON_ENR_1: "furnance_iron_enr_1",
  FURNANCE_IRON_NUGGET_1: "furnance_iron_nugget_1",
  FURNANCE_IRON_NUGGET_2: "furnance_iron_nugget_2",
  FURNANCE_QUARTZ_ENR_1: "furnance_quartz_enr_1",
  FURNANCE_QUARTZ_GLASS_1: "furnance_quartz_glass_1",
  FURNANCE_QUARTZ_GLASS_2: "furnance_quartz_glass_2",
  GRINDER_CARBON_POWDER_1: "grinder_carbon_powder_1",
  GRINDER_COPPER_POWDER_1: "grinder_copper_powder_1",
  GRINDER_CRYSTAL_POWDER_1: "grinder_crystal_powder_1",
  GRINDER_IRON_POWDER_1: "grinder_iron_powder_1",
  GRINDER_ORIGINIUM_POWDER_1: "grinder_originium_powder_1",
  GRINDER_PLANT_BBFLOWER_POWDER_1_1: "grinder_plant_bbflower_powder_1_1",
  GRINDER_PLANT_GRASS_POWDER_1_1: "grinder_plant_grass_powder_1_1",
  GRINDER_PLANT_GRASS_POWDER_2_1: "grinder_plant_grass_powder_2_1",
  GRINDER_PLANT_MOSS_POWDER_1_1: "grinder_plant_moss_powder_1_1",
  GRINDER_PLANT_MOSS_POWDER_2_1: "grinder_plant_moss_powder_2_1",
  GRINDER_PLANT_MOSS_POWDER_3_1: "grinder_plant_moss_powder_3_1",
  GRINDER_QUARTZ_POWDER_1: "grinder_quartz_powder_1",
  LIQUID_PURIFIER_COPPER_ENR_1: "liquid_purifier_copper_enr_1",
  LIQUID_PURIFIER_XIRANITE_POLY_1: "liquid_purifier_xiranite_poly_1",
  PLANTER_PLANT_BBFLOWER_1: "planter_plant_bbflower_1",
  PLANTER_PLANT_GRASS_1_1: "planter_plant_grass_1_1",
  PLANTER_PLANT_GRASS_2_1: "planter_plant_grass_2_1",
  PLANTER_PLANT_MOSS_1_1: "planter_plant_moss_1_1",
  PLANTER_PLANT_MOSS_2_1: "planter_plant_moss_2_1",
  PLANTER_PLANT_MOSS_3_1: "planter_plant_moss_3_1",
  POOL_COPPER_ENR_1: "pool_copper_enr_1",
  POOL_COPPER_ENR_2: "pool_copper_enr_2",
  POOL_LIQUID_COPPER_1: "pool_liquid_copper_1",
  POOL_LIQUID_COPPER_2: "pool_liquid_copper_2",
  POOL_LIQUID_LIQUID_XIRANITE_1: "pool_liquid_liquid_xiranite_1",
  POOL_LIQUID_LIQUID_XIRANITE_2: "pool_liquid_liquid_xiranite_2",
  POOL_LIQUID_PLANT_GRASS_1_1: "pool_liquid_plant_grass_1_1",
  POOL_LIQUID_PLANT_GRASS_1_2: "pool_liquid_plant_grass_1_2",
  POOL_LIQUID_PLANT_GRASS_2_1: "pool_liquid_plant_grass_2_1",
  POOL_LIQUID_PLANT_GRASS_2_2: "pool_liquid_plant_grass_2_2",
  POOL_LIQUID_XIRANITE_ENR_1: "pool_liquid_xiranite_enr_1",
  POOL_LIQUID_XIRANITE_ENR_2: "pool_liquid_xiranite_enr_2",
  POOL_LIQUID_XIRANITE_POLY_1: "pool_liquid_xiranite_poly_1",
  POOL_LIQUID_XIRANITE_POLY_2: "pool_liquid_xiranite_poly_2",
  POOL_XIRANITE_POLY_1: "pool_xiranite_poly_1",
  POOL_XIRANITE_POLY_2: "pool_xiranite_poly_2",
  SEEDCOLLECTOR_PLANT_BBFLOWER_1: "seedcollector_plant_bbflower_1",
  SEEDCOLLECTOR_PLANT_GRASS_1_1: "seedcollector_plant_grass_1_1",
  SEEDCOLLECTOR_PLANT_GRASS_2_1: "seedcollector_plant_grass_2_1",
  SEEDCOLLECTOR_PLANT_MOSS_1_1: "seedcollector_plant_moss_1_1",
  SEEDCOLLECTOR_PLANT_MOSS_2_1: "seedcollector_plant_moss_2_1",
  SEEDCOLLECTOR_PLANT_MOSS_3_1: "seedcollector_plant_moss_3_1",
  SEEDCOLLECTOR_PLANT_SP_1: "seedcollector_plant_sp_1",
  SEEDCOLLECTOR_PLANT_SP_2: "seedcollector_plant_sp_2",
  SEEDCOLLECTOR_PLANT_SP_3: "seedcollector_plant_sp_3",
  SEEDCOLLECTOR_PLANT_SP_4: "seedcollector_plant_sp_4",
  SHAPER_ACTIVITY_XIRANITE_BOTTLE_1: "shaper_activity_xiranite_bottle_1",
  SHAPER_ACTIVITY_XIRANITE_ENR_BOTTLE_1:
    "shaper_activity_xiranite_enr_bottle_1",
  SHAPER_COPPER_BOTTLE_1: "shaper_copper_bottle_1",
  SHAPER_COPPER_ENR_BOTTLE_1: "shaper_copper_enr_bottle_1",
  SHAPER_GLASS_BOTTLE_1: "shaper_glass_bottle_1",
  SHAPER_GLASS_ENR_BOTTLE_1: "shaper_glass_enr_bottle_1",
  SHAPER_IRON_BOTTLE_1: "shaper_iron_bottle_1",
  SHAPER_IRON_ENR_BOTTLE_1: "shaper_iron_enr_bottle_1",
  THICKENER_CARBON_ENR_POWDER_1: "thickener_carbon_enr_powder_1",
  THICKENER_CRYSTAL_ENR_POWDER_1: "thickener_crystal_enr_powder_1",
  THICKENER_IRON_ENR_POWDER_1: "thickener_iron_enr_powder_1",
  THICKENER_ORIGINIUM_ENR_POWDER_1: "thickener_originium_enr_powder_1",
  THICKENER_PLANT_MOSS_ENR_POWDER_1_1: "thickener_plant_moss_enr_powder_1_1",
  THICKENER_PLANT_MOSS_ENR_POWDER_2_1: "thickener_plant_moss_enr_powder_2_1",
  THICKENER_QUARTZ_ENR_POWDER_1: "thickener_quartz_enr_powder_1",
  TOOLS_PROC_ACTIVITY_XIRANITE_ENR_HULU_1:
    "tools_proc_activity_xiranite_enr_hulu_1",
  TOOLS_PROC_ACTIVITY_XIRANITE_ENR_TOOL_1:
    "tools_proc_activity_xiranite_enr_tool_1",
  TOOLS_PROC_ACTIVITY_XIRANITE_HULU_1: "tools_proc_activity_xiranite_hulu_1",
  TOOLS_PROC_BATTERY_1_1: "tools_proc_battery_1_1",
  TOOLS_PROC_BATTERY_2_1: "tools_proc_battery_2_1",
  TOOLS_PROC_BATTERY_3_1: "tools_proc_battery_3_1",
  TOOLS_PROC_BATTERY_4_1: "tools_proc_battery_4_1",
  TOOLS_PROC_BATTERY_5_1: "tools_proc_battery_5_1",
  TOOLS_PROC_BOMB_1_1: "tools_proc_bomb_1_1",
  TOOLS_PROC_FOOD_4_1: "tools_proc_food_4_1",
  TOOLS_PROC_FOOD_5_1: "tools_proc_food_5_1",
  TOOLS_PROC_REC_HP_4_1: "tools_proc_rec_hp_4_1",
  TOOLS_PROC_REC_HP_5_1: "tools_proc_rec_hp_5_1",
  WINDER_EQUIP_SCRIPT_1: "winder_equip_script_1",
  WINDER_EQUIP_SCRIPT_2: "winder_equip_script_2",
  WINDER_EQUIP_SCRIPT_3: "winder_equip_script_3",
  WINDER_EQUIP_SCRIPT_4: "winder_equip_script_4",
  WINDER_EQUIP_SCRIPT_4_1: "winder_equip_script_4_1",
  WINDER_EQUIP_SCRIPT_4_2: "winder_equip_script_4_2",
  XIRANITE_OVEN_MUCK_XIRANITE_1: "xiranite_oven_muck_xiranite_1",
  XIRANITE_OVEN_XIRANITE_ENR_POWDER_1: "xiranite_oven_xiranite_enr_powder_1",
  XIRANITE_OVEN_XIRANITE_POWDER_1: "xiranite_oven_xiranite_powder_1",
} as const;
type RecipeId = (typeof RecipeId)[keyof typeof RecipeId];

const FacilityId = {
  COMPONENT_MC_1: "component_mc_1",
  DISMANTLER_1: "dismantler_1",
  FILLING_POWDER_MC_1: "filling_powder_mc_1",
  FURNANCE_1: "furnance_1",
  GRINDER_1: "grinder_1",
  LIQUID_CLEANER_1: "liquid_cleaner_1",
  LIQUID_PURIFIER_1: "liquid_purifier_1",
  LOADER_1: "loader_1",
  MIX_POOL_1: "mix_pool_1",
  MIX_POOL_2: "mix_pool_2",
  PLANTER_1: "planter_1",
  PUMP_1: "pump_1",
  PUMP_2: "pump_2",
  SEEDCOLLECTOR_1: "seedcollector_1",
  SHAPER_1: "shaper_1",
  THICKENER_1: "thickener_1",
  // NOTE: "assebling" is a typo from the upstream `FactoryBuildingTable`
  // game-data dump. Preserved verbatim so the `bun run extract:recipes`
  // pipeline keeps matching upstream IDs. Do not rename locally — see
  // `public/images/facilities/tools_assebling_mc_1.png` and the recipe
  // `facilityId` references in `src/data/recipes.ts`.
  TOOLS_ASSEBLING_MC_1: "tools_assebling_mc_1",
  UNLOADER_1: "unloader_1",
  WINDER_1: "winder_1",
  XIRANITE_OVEN_1: "xiranite_oven_1",
} as const;
type FacilityId = (typeof FacilityId)[keyof typeof FacilityId];

/**
 * Opaque brand for multi-formula bin identifiers.
 *
 * Unlike ItemId / RecipeId / FacilityId (which are literal-string unions of
 * the closed game-data enum), bin IDs are constructed dynamically by Phase 3
 * (`makeBinId` in `multi-formula-packing.ts`) and follow the format
 * `bin-<facilityId>-<recipeId...>-<emitIdx>`. Brand intersection gives
 * nominal typing without imposing a closed set: a plain `string` cannot be
 * passed where a `BinId` is expected, but `"bin-..." as BinId` works at
 * known-good construction sites (the packer and test fixtures).
 *
 * Distinct from synthetic IDs used by mapper sinks (e.g.
 * `disposal-<recipeId>`, `<binId>-bldg<idx>`, target-sink IDs) — those
 * remain plain `string` because they're union-typed mixtures of bin and
 * non-bin IDs at the consumer.
 */
type BinId = string & { readonly __brand: "BinId" };

export { ItemId, RecipeId, FacilityId };
export type {
  ItemId as ItemIdType,
  RecipeId as RecipeIdType,
  FacilityId as FacilityIdType,
  BinId,
};
